const CACHE_TTL_MS = 60 * 60 * 1000; // 1 hour

export async function getOpenSeaAccountName(walletAddress) {
    const cacheKey = `opensea_username_${walletAddress}`;
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
        try {
            const { username, ts } = JSON.parse(cached);
            if (Date.now() - ts < CACHE_TTL_MS) return username;
        } catch {
            // ignore corrupt cache entry
        }
    }

    // Calls our server-side proxy — keeps the API key out of the browser bundle
    const url = `/api/opensea/account/${walletAddress}`;

    try {
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        // Guard against static-hosting fallback returning index.html instead of JSON
        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
            return 'Unknown';
        }

        const data = await response.json();
        const username = data?.username || 'Unknown';
        localStorage.setItem(cacheKey, JSON.stringify({ username, ts: Date.now() }));
        return username;
    } catch (error) {
        return 'Unknown';
    }
}
